/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />
/// <reference path="../../customtypings/notification/notification.d.ts" />

/**
 * Notification service
 */
namespace Application.Services {
    'use strict';

    const PERMISSION_GRANTED: string = 'granted';

    /**
     * NotificationService
     */
    export class NotificationService {
        public static $name: string = "notificationService";
        public static $inject: string[] = ['$rootScope'];

        constructor(private $rootScope: Services.IFlexSettings) {
            // this.requestPermission(); // users without permission to see alarms won't be asked for permission to show notifications
        }

        public showNotification(msg: string, url?: string): void {
            if (this.$rootScope.settings.notifications && Notification && this.$rootScope.flexSections.getSectionWithId(21).canRead) {
                if (Notification.permission !== PERMISSION_GRANTED) {
                    Notification.requestPermission();
                } else {
                    let notification: Notification = new Notification('Eurovision FLEX', {
                        icon: 'images/flex-ebu-eye-white-192.png',
                        body: msg,
                        sound: '',
                    });

                    if (url) {
                        notification.onclick = (): void => {
                            window.open(url);
                            notification.close();
                        };
                    } else {
                        notification.onclick = (): void => {
                            parent.focus();
                            notification.close();
                        };
                    }

                    // Hack to get notification sound on most browsers
                    document.getElementById("audioPlayerContainer").innerHTML = 
                        '<audio autoplay="autoplay"><source src="sounds/notification.mp3" type="audio/mpeg" /></audio>';
                }
            }
        }

        public requestPermission(): void {
            if (this.$rootScope.settings.notifications && Notification && Notification.permission !== PERMISSION_GRANTED) {
                Notification.requestPermission();
            }
        }
    }
}